import DynamicForm from '../components/dynamicForm';

const Warranty = () => {
  const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format

  const fields = [
    { id: 'first_name', type: 'text', placeholder: 'الاسم الأول', required: true },
    { id: 'last_name', type: 'text', placeholder: 'الاسم الأخير', required: true },
    { id: 'email', type: 'email', placeholder: 'البريد الإلكتروني', required: true },
    { id: 'mobile', type: 'phone', placeholder: 'رقم الجوال', required: true },
    { id: 'birthday', type: 'date', placeholder: 'تاريخ الميلاد', required: true, max: today, min: '1900-01-01' },
    { id: 'purchaseDate', type: 'date', placeholder: 'تاريخ الشراء', required: true, max: today, min: '2010-01-01' },
    { id: 'order_id', type: 'text', placeholder: 'رقم الطلب', required: true },
    { id: 'model_no', type: 'text', placeholder: 'رقم الموديل', required: true },
    { 
      id: 'IsGift', 
      type: 'select', 
      placeholder: 'هل كان المنتج هدية', 
      options: [
        { label: 'نعم', value: 'نعم' }, 
        { label: 'لا', value: 'لا' }
      ], 
      required: true 
    },
  ];

  return (
    <DynamicForm
      formType="Warranty"
      fields={fields}
      title="ضمان"
      introText={[
        "منتج صنع بحب ليبقى معك",
        "سجل منتجك في دقيقة واحدة",
        "واحصل على ضمان لـ{brandWarranty}",
      ].join("\n")}
    />
  );
};

export default Warranty;
